import Modal from './index'

export default {
  Modal,
}
